const faceComparisonReducer = (
  state = {
    loading: false,
    data: null,
    captures: null,
    offlineRequests: null
  },
  action
) => {
  switch (action.type) {
    case "SET_FACE_COMPARISON_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_FACE_COMPARISON_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "PUT_CAPTURE":
      return {
        ...state,
        captures: action.payload
      };

    case "UPDATE_CAPTURE_WITH_ASSETS":
      return {
        ...state,
        captures: action.payload
      };

    case "PUT_OFFLINE_CAPTURES":
      return {
        ...state,
        offlineRequests: action.payload
      };

    case "CLEAR_FACE_COMPARISON_DATA":
      return {
        ...state,
        data: null
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default faceComparisonReducer;
